import { add } from 'date-fns';

export function utcToLocalTime(date: Date): Date {
  const offset = date.getTimezoneOffset();
  return add(date, { minutes: offset });
}
